module.exports = __webpack_public_path__ + "static/img/ranking-use.028eab0f.png";